import React from "react";
// import AllServices from "../components/AllServices";
import AboutBC from "../assets/img/aboutbc.png";
import AboutImg from "../assets/img/about.jpg";
import Button from "../components/Button";

export default function About() {
  return (
    <>
      <div className="pt-10">
        <img src={AboutBC} alt="" className="w-100 img-fluid" />
      </div>

      <div className="container pt-5 pb-5 section">
        <div className="row align-items-center">
          <div className="col-md-6">
            <h2 className="pb-3 heading">About Us</h2>
            <h4 className="subheading">
              {" "}
              From Concept to Completion, Seamlessly Delivered
            </h4>
            <p>
              YANAA HOMES is a full-service interior design firm that designs
              spaces from concept to completion in Bengaluru. We create custom
              interiors for new builds and renovation projects.
            </p>
            <p>
              Our USP is centered around remote project management, specifically
              catering to clients located in different regions or countries,
              where we undertake full responsibility for executing the project
              with minimal input from them. "Not only do we take up Turnkey
              projects but we also have expertise in providing “Quickfix”
              solutions to clients who are on a rental space or on a tight
              timeline.
            </p>
            <Button
              to="https://wa.me/917022851682/"
              title="Start Project"
              className="btn primary"
            />
          </div>
          <div className="col-md-6">
            <img src={AboutImg} alt="" className="w-100 img-fluid" />
          </div>
        </div>
      </div>

      {/* <AllServices /> */}
    </>
  );
}
